import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../../components/Button';
import LongTermDisabilityServicesModal from './LongTermDisabilityServiceModal';

const LongTermDisabilityServicesModalDemo = () => {
  const [
    showLongTermDisabilityServicesModal,
    setShowLongTermDisabilityServicesModal,
  ] = React.useState<boolean>(false);

  const handleShowLongTermDisabilityServicesModal = () =>
    setShowLongTermDisabilityServicesModal(true);
  const handleCloseLongTermDisabilityServicesModal = () =>
    setShowLongTermDisabilityServicesModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Long Term Disability Services Modal</h4>
        <Button onMouseDown={handleShowLongTermDisabilityServicesModal}>
          Open Modal
        </Button>
        <LongTermDisabilityServicesModal
          showLongTermDisabilityServicesModal={
            showLongTermDisabilityServicesModal
          }
          handleCloseLongTermDisabilityServicesModal={
            handleCloseLongTermDisabilityServicesModal
          }
        />
      </Container>
    </Container>
  );
};

export default LongTermDisabilityServicesModalDemo;
